import { StyledMaxWidth } from './styled';

const MaxWidth = StyledMaxWidth;
export default MaxWidth;